import React from "react";
import NavTop2Component from "../../../components/user/NavTop2Component";
import LandingNavFemale from "../LandingNavFemale";
import NailHomeSection from "./PageComponent/NailHomeSection";
import NumberIncrementComponent from "../../../components/user/NumberIncrementComponent";
import NailServicesComponent from "./PageComponent/NailServicesComponent";
import WhyUsNail from "./PageComponent/WhyUsNail";
import CustomerFeedbackForNailPage from "./PageComponent/CustomerFeedbackForNailPage";
import FaqNailPage from "./PageComponent/FaqNailPage";
import FooterNailPage from "./PageComponent/Footernailpage";
import BookingStepsSection from "./PageComponent/Bookingstepssection";
import NailartLocationSection from "./PageComponent/NailartLocationSection";

function NailArtLandingPage() {
  return (
    <div>
      <div className="landing-page-navbar">
        <NavTop2Component />

        <LandingNavFemale />
      </div>

      <NailHomeSection />
      <NumberIncrementComponent />
      <NailServicesComponent/>
      <BookingStepsSection/>
      <WhyUsNail/>
      <CustomerFeedbackForNailPage/>
      <NailartLocationSection/>

      
<div>



  <FaqNailPage/>

</div>
<FooterNailPage/>
    </div>
  );
}

export default NailArtLandingPage;
